import type { Cart } from '@/modules/cart/domain/Cart';

export const extractCartItemSkus = (cart: Cart) => {
  return cart?.lineItems?.map((item) => ({
    sku: item?.variant?.sku ?? ''
  }));
};
